import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import './App.css';
import AdminLayout from './Layouts/Admin/layout';
import MainFirm from './Layouts/Firm/main-firm';
import PrimeReactUi from './Layouts/User/prime-react-ui';
import Screen1P from './Pages/UserFirms/screen1';
// import Screen2P from './Pages/UserFirms/screen2';
import Screen3P from './Pages/UserFirms/screen3';
import Setting from './Pages/UserFirms/setting';
import Login from './Pages/login';
import { AuthProvider, RequireAuth, useSignOut } from './auth/AuthService';
import UserPreference from './Pages/UserIcsx/userPreference';
import Disclaimer from './Pages/UserIcsx/disclaimer';
import UserPreferenceFirm from './Pages/UserFirms/userPreferenceFirm';
import DisclaimerFirm from './Pages/UserFirms/disclaimerFirm';
import MarketSummary from './Pages/UserIcsx/marketSummary';
import CurrentStock from './Pages/UserIcsx/currentStock';
import Disclosure from './Pages/UserIcsx/disclosure';
import DisclosureDetail from './Pages/UserIcsx/diclosure-detail';
import HistoryPrice from './Pages/UserIcsx/history-price';
import HistoricalIndex from './Pages/UserIcsx/history-index';
import StockInfo from './Pages/UserIcsx/stock-info';
import UserPage from './Pages/Admin/user';
import UserOnline from './Pages/Admin/userOnline';
import { LayoutProvider } from './Layouts/Admin/layoutcontext';
import Group from './Pages/Admin/group';
import Firm from './Pages/Admin/firm';
import Stock from './Pages/Admin/stock';
import Menu from './Pages/Admin/menu';
import Calender from './Pages/Admin/calender';
import Advertise from './Pages/Admin/advertise';
import UserGuide from './Pages/Admin/userGuide';
import UserStatistic from './Pages/Admin/userStatistic';
import Screen2 from './Pages/UserFirms/screen2';
import UserPreferenceAdmin from './Pages/Admin/userPreferenceAdmin';
import DisclaimerAdmin from './Pages/Admin/disclaimerAdmin';
import Index from './Pages/UserFeed/Feeds/Index';
import StockFeed from './Pages/UserFeed/Feeds/StockFeed';
import DisclosureFeed from './Pages/UserFeed/Feeds/disclosure';
import GmsIndex from './Pages/UserFeed/GmsFeeds/gmsIndex';
import GmsStockFeed from './Pages/UserFeed/GmsFeeds/gmsStockFeed';
import GmsDisclosureFeed from './Pages/UserFeed/GmsFeeds/gmsDisclosure';
import Screen1Issuer from './Pages/UserFirms/screen1Issuer';
import Home from './Pages/home';
import UserManagerPage from './Pages/Admin/userManager';

function App() {
  return (
    <div className="App">
      <AuthProvider
        authType={'cookie'}
        authName={'_auth'}
        cookieDomain={window.location.hostname}
        cookieSecure={true}
      >
        <BrowserRouter>
          <Routes>
            {/* <Route element={<AdminLayout/>}> */}
            {/* <Route element={<RequireAuth loginPath={'/login'}></RequireAuth>}> */}
              <Route path='/feeds/index.rss' element={<RequireAuth loginPath={'/login'} roles={['admin', 'subscriber']}><Index/></RequireAuth>}></Route>
              <Route path='/feeds/stock.rss' element={<RequireAuth loginPath={'/login'} roles={['admin', 'subscriber']}><StockFeed/></RequireAuth>}></Route>
              <Route path='/feeds/disclosure.rss' element={<RequireAuth loginPath={'/login'} roles={['admin', 'subscriber']}><DisclosureFeed/></RequireAuth>}></Route>
              <Route path='/gms_feeds/index.rss' element={<RequireAuth loginPath={'/login'} roles={['admin', 'gms']}><GmsIndex/></RequireAuth>}></Route>
              <Route path='/gms_feeds/stock.rss' element={<RequireAuth loginPath={'/login'} roles={['admin', 'gms']}><GmsStockFeed/></RequireAuth>}></Route>
              <Route path='/gms_feeds/disclosure.rss' element={<RequireAuth loginPath={'/login'} roles={['admin', 'gms']}><GmsDisclosureFeed/></RequireAuth>}></Route>
            {/* </Route> */}
            <Route element={<RequireAuth loginPath={'/login'}  roles={['admin']}><LayoutProvider><AdminLayout/></LayoutProvider></RequireAuth>}>
              <Route path='/admin/online-user' element={<UserOnline/>}></Route>
              <Route path='/admin/group' element={<Group/>}></Route>
              <Route path='/admin/firm' element={<Firm/>}></Route>
              <Route path='/admin/stock' element={<Stock/>}></Route>
              <Route path='/admin/menu' element={<Menu/>}></Route>
              <Route path='/admin/calender' element={<Calender/>}></Route>
              <Route path='/admin/advertise' element={<Advertise/>}></Route>
              <Route path='/admin/user-statistic' element={<UserStatistic/>}></Route>
            </Route>
            <Route element={<RequireAuth loginPath={'/login'}  roles={['admin', 'manager']}><LayoutProvider><AdminLayout/></LayoutProvider></RequireAuth>}>
              <Route path='/admin/manager/user' element={<UserManagerPage/>}></Route>
              <Route path='/admin/user-guide' element={<UserGuide/>}></Route>
              <Route path='/admin/user/edit' element={<UserPreferenceAdmin/>}></Route>
              <Route path='/admin/disclaimer' element={<DisclaimerAdmin/>}></Route>
            </Route>
            <Route element={<RequireAuth loginPath={'/login'}  roles={['admin']}><LayoutProvider><AdminLayout/></LayoutProvider></RequireAuth>}>
              <Route path='/admin/user' element={<UserPage/>}></Route>
            </Route>
            {/* <Route element={<MainFirm/>}> */}
            <Route element={<RequireAuth loginPath={'/login'}  roles={['member_firm', 'issuer']}><MainFirm/></RequireAuth>}>
              <Route path='/screen2' element={<Screen2/>}></Route>
              <Route path='/screen3' element={<Screen3P/>}></Route>
              <Route path='/setting' element={<Setting/>}></Route>
              <Route path='/firm/user/edit' element={<UserPreferenceFirm/>}></Route>
              <Route path='/firm/disclaimer' element={<DisclaimerFirm/>}></Route>
            </Route>
            <Route element={<RequireAuth loginPath={'/login'}  roles={['member_firm']}><MainFirm/></RequireAuth>}>
              <Route path='/screen1' element={<Screen1P/>}></Route>
            </Route>
            <Route element={<RequireAuth loginPath={'/login'}  roles={['issuer']}><MainFirm/></RequireAuth>}>
              <Route path='/screen1_issuer' element={<Screen1Issuer/>}></Route>
            </Route>
            <Route element={<RequireAuth loginPath={'/login'} roles={['user', 'investor', 'secc']}><PrimeReactUi/></RequireAuth>}>
              <Route path='/market-summary' element={<MarketSummary/>}></Route>
              <Route path='/current-stock' element={<CurrentStock/>}></Route>
              <Route path='/disclosures' element={<Disclosure/>}></Route>
              <Route path='/disclosures/:id' element={<DisclosureDetail/>}></Route>
              <Route path='/historical-price' element={<HistoryPrice/>}></Route>
              <Route path='/historical-index' element={<HistoricalIndex/>}></Route>
              <Route path='/stock-info' element={<StockInfo/>}></Route>
              <Route path='/user/edit' element={<UserPreference/>}></Route>
              <Route path='/disclaimer' element={<Disclaimer/>}></Route>
            </Route>
            <Route path='/' element={<RequireAuth loginPath={'/login'}><Home/></RequireAuth>}></Route>
            <Route path='/login' element={<Login></Login>}></Route>
            <Route path='/:path' element={<Home/>}></Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      
    </div>
  );
}

export default App;
